import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Reviews from "./components/Reviews";
import BeforeAfterGallery from "./components/BeforeAfterGallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="App">
          <Header />
          <main>
            <Hero />
            <Marquee />
            <About />
            <Services />
            <WhyChooseUs />
            <Reviews />
            <BeforeAfterGallery />
            <Contact />
          </main>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
